import { required, shape, stopOnFirstFailure, maxLength } from '@totalsoft/pure-validations';

export const requiredDocumentValidator = shape({
  documentName: [required, maxLength(500)] |> stopOnFirstFailure,
  documentCode: [required, maxLength(15)] |> stopOnFirstFailure,
  sharePointContentType: [required, maxLength(500)] |> stopOnFirstFailure
});
